import React from "react";
import {Form, Input, Modal} from "antd";
import {FormModalProps} from "../../utils/useFormModal";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'name'} label={'外部系统名称'}
                           rules={[{required: true, message: '请输入外部系统名称'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'api'} label={'外部系统地址'}
                           rules={[{required: true, message: '请输入外部系统地址'}]}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
